import React, { useEffect, useRef, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { departmentColor, legendDepartments } from '../orgChartModel';

// Departman lejantı (spec 2026-10-24 §5.4): yalnız EKRANDAKİ kartların departmanları, kart sayısına göre; ilk 6 + "+N".
const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  font: 12px 'Nunito Sans', sans-serif;
  color: ${({ theme }) => theme.colors.text.muted};
  position: relative;
`;

const Item = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
`;

const Dot = styled.i`
  width: 9px;
  height: 9px;
  border-radius: 3px;
  display: inline-block;
  background: ${({ $color }) => $color};
`;

const MoreBtn = styled.button`
  border: 1px solid #E6EAF0;
  background: #fff;
  border-radius: 999px;
  padding: 1px 8px;
  font: 700 11px 'Nunito Sans', sans-serif;
  color: ${({ theme }) => theme.colors.text.muted};
  cursor: pointer;
`;

const Menu = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 20;
  background: #fff;
  border: 1px solid #E6EAF0;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 260px;
  overflow-y: auto;
`;

export default function Legend({ nodes }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const palette = { colors: theme.colors.orgChart.departmentPalette, neutral: theme.colors.orgChart.neutral };
  const { shown, hidden, rest } = legendDepartments(nodes);

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  if (!shown.length) return null;
  const item = (d) => (
    <Item key={d.id} data-testid={`legend-${d.id}`}>
      <Dot $color={departmentColor(d.id, palette)} />
      {d.name}
    </Item>
  );
  return (
    <Row data-testid="org-legend" ref={ref}>
      {shown.map(item)}
      {rest > 0 && (
        <MoreBtn type="button" data-testid="legend-more" onClick={() => setOpen((v) => !v)}>
          {t('orgChart.legendMore', { count: rest })}
        </MoreBtn>
      )}
      {open && <Menu data-testid="legend-menu">{hidden.map(item)}</Menu>}
    </Row>
  );
}
